export enum OnComponentTrimStyle {
  ClassicArch = 'classic-arch',
  Clear = 'clear',
  CornerBlock = 'corner-block',
  CornerBlockOpen = 'corner-block-open',
  CornerBlockOpenPerimeterOnly = 'corner-block-open-perimeter-only',
  CountryStyle = 'country-style',
  Custom1100 = 'custom-1-1-0-0',
  Custom1101 = 'custom-1-1-0-1',
  Custom1111 = 'custom-1-1-1-1',
  DutchDoor = 'dutch-door',
  DutchDoorSummitStyle = 'dutch-door-summit-style',
  FullArchSixInchBottomTrim = 'full-arch-six-inch-bottom-trim',
  FullX = 'full-x',
  FullXTopArch = 'full-x-top-arch',
  LeftCornerBlock = 'left-corner-block',
  LeftFullXTopArch = 'left-full-x-top-arch',
  LeftGardenArch = 'left-garden-arch',
  LeftGardenArchLowerCornerBlockOpen = 'left-garden-arch-lower-corner-block-open',
  LeftGardenArchSixInchBottomTrim = 'left-garden-arch-six-inch-bottom-trim',
  LowerCornerBlock = 'lower-corner-block',
  LowerCornerBlockOpen = 'lower-corner-block-open',
  LowerVertical = 'lower-vertical',
  LowerX = 'lower-x',
  PerimeterOnly = 'perimeter-only',
  ProSeriesTrim = 'pro-series-trim',
  RightCornerBlock = 'right-corner-block',
  RightFullXTopArch = 'right-full-x-top-arch',
  RightGardenArch = 'right-garden-arch',
  RightGardenArchLowerCornerBlockOpen = 'right-garden-arch-lower-corner-block-open',
  RightGardenArchSixInchBottomTrim = 'right-garden-arch-six-inch-bottom-trim',
  SixInchBottomTrim = 'six-inch-bottom-trim',
  SvgTrim = 'svg-trim',
  TopShedTStyle = 'top-shed-t-style',
  UpperCornerBlockOpenLowerX = 'upper-corner-block-open-lowerX',
}
